var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.5625,
    height: 20,
    viewBox: "0 0 36.1 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FECB00",
    d: "M2.8,31.5c-0.8,0-1.6-0.4-2-1.1c-0.4-0.7-0.4-1.6,0-2.3L16.1,1.6c0.4-0.7,1.2-1.1,2-1.1s1.6,0.4,2,1.1 l15.3,26.5c0.4,0.7,0.4,1.6,0,2.3c-0.4,0.7-1.2,1.1-2,1.1H2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18,1c0.6,0,1.2,0.3,1.5,0.9l15.3,26.5c0.3,0.5,0.3,1.2,0,1.8C34.5,30.7,34,31,33.3,31H2.8c-0.6,0-1.2-0.3-1.5-0.9 c-0.3-0.5-0.3-1.2,0-1.8L16.5,1.9C16.8,1.3,17.4,1,18,1 M18,0c-1,0-1.9,0.5-2.4,1.4L0.4,27.9c-0.5,0.9-0.5,1.9,0,2.8 C0.9,31.5,1.8,32,2.8,32h30.6c1,0,1.9-0.5,2.4-1.4c0.5-0.9,0.5-1.9,0-2.8L20.4,1.4C19.9,0.5,19,0,18,0L18,0z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.5712 27.1919)",
    style: {
      fontWeight: "bold",
      fontSize: 24,
      color: "#000"
    }
  }, "!"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerError);
export default __webpack_public_path__ + "static/media/banner-error.9248c1268a2c6c2a341f5c0d35412b5e.svg";
export { ForwardRef as ReactComponent };